import {useEffect} from 'react';
import {AnonymousDiagnosticReport} from '@legit.health/ui';
import {Box} from '@mui/material';
import {TFunction} from 'i18next';
import Backdrop from '@/components/Backdrop';
import postAnalysisCompletedMessage from '@/utils/postAnalysisCompletedMessage';

export default function ImageSent({
  diagnosticReport
}: {
  t: TFunction;
  diagnosticReport: AnonymousDiagnosticReport;
}) {
  useEffect(
    function () {
      postAnalysisCompletedMessage(diagnosticReport.id);
    },
    [diagnosticReport.id]
  );

  return (
    <Box sx={{minHeight: '100vh'}} data-testid="imageSentContainer">
      <Backdrop />
    </Box>
  );
}
